<template>
	<div class="backgroundAudio">
		<h5>Background Audio</h5>
		
		<div v-if="hasBackgroundAudio">
			<AudioUploader @file-added="updateFileNames"></AudioUploader>
			<div class="form-group" v-for="(property, size) in componentItemContent['background-audio']" :key="size">
				<label>{{ size }}</label>
				<input type="text" class="form-control" :id="size" v-model="componentItemContent['background-audio'][size]" >
			</div>
		
		</div>

		<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="addBackgroundAudio">
			<img src="~@/assets/icons/add.svg">
		</button>

		<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="removeBackgroundAudio">
			<img src="~@/assets/icons/minus.svg">
		</button>
 
	</div>
</template>

<script>
	import AudioUploader from './AudioUploader';
	export default {
		components: {
			AudioUploader
		},		
		name: 'BackgroundAudio',

		props: ['componentItemContent'],

		data() {
			return {
				hasBackgroundAudio: false,
			}
		},
		
		mounted() {
			if(this.componentItemContent['background-audio']) {
				this.hasBackgroundAudio = true;
			}
		},

		methods: {
			updateFileNames:function(fileName){
				this.componentItemContent['background-audio']['source'] = fileName
			},
			addBackgroundAudio() {
				this.componentItemContent['background-audio'] = {
					'source': ''
				}
				this.hasBackgroundAudio = true;
			},
			removeBackgroundAudio() {
				delete this.componentItemContent['background-audio'];
				this.hasBackgroundAudio = false;
			},
		}

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	.backgroundAudio{
		padding:20px 0;
	}

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>